import BaseAPI from './base/base-api';

class MisaStoreAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'misastore';
}

export default new MisaStoreAPI();